import {Platform} from 'react-native';
import {KEYS} from './Constants';
import {getData, removeData, storeData} from './GeneralStorage';
import {clearRefreshToken} from './TokenStore';
import Config from 'react-native-config';
const RNConfig = Config || {};

/**
 * @function validateEmail
 * @param email: String
 * @returns Bool
 * @description Function identify given string is valid email address or not and returns true/false
 */
export const validateEmail = email => {
  let reg =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return reg.test(email);
};

/**
 * @function validPassword
 * @param password: String
 * @returns Bool
 * @description Function identify given string is valid password or not and returns true/false
 *
 * valid password must contain at least 1 lower case, 1 upper case, 1 digit, 1 special character and must have minimum 8 character long
 */
export const validPassword = password => {
  const strongRegex = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})',
  );
  return strongRegex.test(password);
};

/**
 * @function validName
 * @param name: String
 * @returns Bool
 * @description Function identify given string is valid name or not and returns true/false
 *
 * valid Name must only contain letters
 */
export const validName = name => {
  // const strongRegex =
  //   /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u; //new RegExp('^[a-zA-Z]+$');
  // return strongRegex.test(name);
  return trimSpace(name).length > 0;
};

/**
 * @function trimSpace
 * @param name: String
 * @returns String
 * @description Function trims the white space from front and tail of the given string
 *
 */
export const trimSpace = name => {
  return name.trim();
};

/**
 * @function validateUSZipCode
 * @param zip: String
 * @returns Bool
 * @description Function identify given string is valid zip code for US or not and returns true/false
 *
 */
export const validateUSZipCode = zip => {
  const reg = /^[0-9]{5}(?:-[0-9]{4})?$/;
  return reg.test(zip);
};

/**
 * @function validPhoneNumberWithExtension
 * @param phoneNumber: String
 * @returns Bool
 * @description Function identify given string is valid password or not and returns true/false
 *
 * valid phone number must be of the format +1 (xxx)(xxx)(xxxx) - 10 digits preceded by a +1
 */
export const validPhoneNumberWithExtension = phoneNumber => {
  const reg = /^(\+1)\d{10}$/;
  return reg.test(phoneNumber);
};

/**
 * @function isEmpty
 * @param data: String/Array
 * @returns Bool
 * @description Function identify given object is empty or not and returns true/false
 *
 */
export const isEmpty = data => {
  if (data) {
    if (typeof data === 'string') {
      return data.length == 0;
    } else if (typeof data === 'object') {
      if (data instanceof Object) {
        return Object.keys.length == 0;
      } else if (data instanceof Array) {
        return data.length == 0;
      }
    }
  }
  return true;
};

/**
 * @function getCountryCode
 * @returns String
 * @description Function return contry code
 *
 * valid phone number must be of the format +1 (xxx)(xxx)(xxxx) - 10 digits preceded by a +1
 */
export const getCountryCode = () => {
  return '+1';
};

/**
 * @function getBiometricLabel
 * @returns String
 * @description Platform-appropriate name for the biometric-unlock feature. iOS
 * surfaces Face ID; react-native-biometrics reports only a generic type on
 * Android (fingerprint or face unlock), so we use neutral copy there.
 */
export const getBiometricLabel = () =>
  Platform.OS === 'ios' ? 'Face ID' : 'Biometric Login';

/**
 * @function transformPhoneForAPI
 * @returns String
 * @description Function return contry code
 *
 * valid phone number must be of the format +1 (xxx)(xxx)(xxxx) - 10 digits preceded by a +1
 */
export const transformPhoneForAPI = phone => {
  //return if it has dashes
  let phoneWithoutExtension;
  if (phone?.length == 10) {
    phoneWithoutExtension = phone;
  } else {
    phoneWithoutExtension = phone?.substring(getCountryCode().length);
  }
  return (
    phoneWithoutExtension?.substring(0, 3) +
    '-' +
    phoneWithoutExtension?.substring(3, 6) +
    '-' +
    phoneWithoutExtension?.substring(6)
  );
};

/**
 * @function DLog
 * @param log arguments
 * @description Function console the logs only in development mode
 *
 * Arguments are same as pass to the console.log function. This function is used for show logs only in development environment not in production.
 * Usage:  DLog('Console string', variableIfNeeded);
 */

export const DLog = (...args) => {
  if (__DEV__) {
    console.log(...args);
  }
};

/**
 * @function getGreetingText
 * @description Function retuens greetings string based on current time
 */

export const getGreetingText = () => {
  var today = new Date();
  var curHr = today.getHours();

  if (curHr < 12) {
    return 'Morning';
  } else if (curHr < 17) {
    return 'Afternoon';
  } else {
    return 'Evening';
  }
};

export const convertDateToTime = date => {
  const timeStamp = new Date(date).getTime();
  const currentTime = new Date().getTime();
  const diff = (timeStamp - currentTime) / 1000;
  const sec = 60;
  const min = 60 * 60;
  const hour = 60 * 60 * 24;
  let time = '';
  if (diff < sec) {
    time = '2 Min';
  } else if (diff < min) {
    time = Math.ceil(diff / sec) + ' Min';
  } else if (diff < hour) {
    time = Math.ceil(diff / min) + ' Hours';
  } else {
    time = Math.ceil(diff / hour) + ' Days';
  }
  // console.log('time and diff', time, diff);
  return time;
};

export const objToQueryString = obj => {
  const keyValuePairs = [];
  for (const key in obj) {
    keyValuePairs.push(
      encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]),
    );
  }
  return keyValuePairs.join('&');
};

/*
 * @param fontFileName - font name in resources
 * @param fileFormat - ttf or otf
 * @returns {string} - css for webview
 */
export const generateAssetsFontCss = (fontFileName, fileFormat) => {
  const fileUri = Platform.select({
    ios: `${fontFileName}.${fileFormat}`,
    android: `file:///android_asset/fonts/${fontFileName}.${fileFormat}`,
  });

  return `
  @font-face {
          font-family: '${fontFileName}';
      src: local('${fontFileName}'), url('${fileUri}') format('${
    fileFormat === 'ttf' ? 'truetype' : 'opentype'
  }');
  }
  `;
};

/*
 * @param base64Image - base64 image string
 * @returns {Blob} - blob file
 */
export function DataURIToBlob(base64Image) {
  const splitDataURI = base64Image.split(',');
  const byteString =
    splitDataURI[0].indexOf('base64') >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], {type: mimeString});
}

//clears all local storage data
export async function removeAllLocalData(ShopC) {
  await removeData(KEYS.isLogin);
  await removeData(KEYS.userId);
  await removeData(KEYS.userToken);
  await removeData(KEYS.userInfo);
  await removeData(KEYS.userEligible);
  await removeData(KEYS.tokenVersion);
  // Logout must revoke the long-lived credential too, not just the access token
  await clearRefreshToken();
  ShopC?.setCartProducts([]);
  ShopC?.setDefaultAddress(null);
  ShopC?.setDefaultCard(null);
}

export async function compareTokenVersions() {
  // If TOKEN_VERSION is not configured, skip version check
  if (!RNConfig.TOKEN_VERSION) {
    return true;
  }
  const tokenVersion = await getData(KEYS.tokenVersion);
  return (
    tokenVersion &&
    parseFloat(RNConfig.TOKEN_VERSION) <= parseFloat(tokenVersion)
  );
}

export async function updateTokenVersion() {
  if (RNConfig.TOKEN_VERSION != null) {
    await storeData(KEYS.tokenVersion, String(RNConfig.TOKEN_VERSION));
  }
}

/**
 * @function transformImageUrl
 * @param imageUrl: String
 * @returns String
 * @description Transforms image URLs to use www subdomain to avoid CORS issues on web
 *
 * web.diathrive.com is hosted on AWS Amplify, while product images are stored on
 * www.diathrive.com (old October CMS server). This function ensures all image URLs
 * point to www.diathrive.com to avoid CORS errors.
 */
export const transformImageUrl = imageUrl => {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return imageUrl;
  }

  // Replace diathrive.com with www.diathrive.com (but not if www already exists)
  if (imageUrl.includes('diathrive.com') && !imageUrl.includes('www.diathrive.com')) {
    return imageUrl.replace(/https?:\/\/diathrive\.com/g, 'https://www.diathrive.com');
  }

  return imageUrl;
};

/**
 * @function formatTimeByPreference
 * @param {Date|string} date - Date object or ISO string
 * @param {string} timeFormat - '12' or '24' (defaults to '24' if not provided)
 * @returns {string} Formatted time string (e.g., "2:30 PM" or "14:30")
 * @description Formats time based on user preference (12-hour or 24-hour format)
 */
export const formatTimeByPreference = async (date, timeFormat = null) => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  // Get preference from storage if not provided
  let format = timeFormat;
  if (!format) {
    format = await getData(KEYS.timeFormat);
  }

  // Default to 24-hour if no preference set
  if (!format || format === '24') {
    // 24-hour format: "14:30"
    return dateObj.toString().substring(16, 21);
  }

  // 12-hour format: "2:30 PM"
  let hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be 12

  const minutesStr = minutes < 10 ? '0' + minutes : minutes;

  return `${hours}:${minutesStr} ${ampm}`;
};
